import { styled } from "@mui/material";

export const ListWrap = styled("div")(() => ({
  padding: '46px 0px', 
  backgroundColor: "var(--color-background-primary)",
}));

export const WrapTabsNav = styled('div')(() => ({
  borderBottom: '1px solid var(--color-grey-40)',
}));

export const BaseTabsNav = styled('div')(() => ({
  maxWidth: '500px',
}));